import { render } from "./MapLegendOtherGridsCCM.vue?vue&type=template&id=3da704f9&scoped=true"
import script from "./MapLegendOtherGridsCCM.vue?vue&type=script&lang=js"
export * from "./MapLegendOtherGridsCCM.vue?vue&type=script&lang=js"

import "./MapLegendOtherGridsCCM.vue?vue&type=style&index=0&id=3da704f9&scoped=true&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3da704f9"]])

export default __exports__